import { Ability, AbilityBuilder } from '@casl/ability';
import { UserEntityPermissionsType } from './user-entity-permissions';

export class CustomAbility extends Ability {
}

function getRulesSubjectName(item: any): string {
    if (!item || typeof item === 'string') {
        return item;
    }
    return UserEntityPermissionsType[item.permissionsGroupType];
}

export const customAbility: CustomAbility = AbilityBuilder.define({ subjectName: getRulesSubjectName }, () => true);

